/**
 * Liquid I.V. Global Tabs Switcher
 * Handles tab-switching behavior globally using event delegation.
 * Supports zero-lag switching and triggers recalculation for sliders.
 */
document.addEventListener('click', function(e) {
  const tabButton = e.target.closest('[data-tab-target]');
  if (!tabButton) return;

  const targetId = tabButton.getAttribute('data-tab-target');
  const targetPanel = document.getElementById(targetId);
  if (!targetPanel) return;

  // Find the closest tab container wrapper to isolate behavior
  const container = tabButton.closest('[data-liv-tabs-container]') || 
                    tabButton.closest('.hydration-product-slider-parent') || 
                    tabButton.closest('.liv-tabbed-collections');
  if (!container) return;

  // Prevent default action for buttons
  e.preventDefault();

  // 1. Toggle active state for tab buttons inside this container
  const buttons = container.querySelectorAll('[data-tab-target]');
  buttons.forEach(btn => {
    btn.classList.toggle('is-active', btn === tabButton);
  });

  // 2. Toggle visibility and active class for tab panels
  const panels = container.querySelectorAll('.hps-tab-panel');
  panels.forEach(panel => {
    const isActive = panel === targetPanel;
    panel.classList.toggle('is-active', isActive);
    panel.style.display = isActive ? 'block' : 'none';
  });

  // 3. Trigger resize event so any active sliders/progress tracks recalculate widths instantly
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 50);
});
